Apt.fn.extend('maps', {}, {
	/**
	 * Bind events for polygons
	 *
	 * @param {String} layer
	 */
	bindPoly(layer) {
		const scope = this;
		const pub = scope.$public;

		pub.bind(layer, 'mousemove', e => {
			if ($.supported('touch')) {
				return;
			}

			if (
				! scope.hoverMarker &&
				! scope.tooltip
			) {
				scope.hoverPoly(layer, e.point);
			}
		});

		pub.bind(layer, 'mouseleave', () => {
			if ($.supported('touch')) {
				return;
			}

			if (! scope.hoverMarker) {
				scope.deactivate();
			}
		});

		pub.bind(layer, 'click', e => {
			if (scope.draw || scope.model.$get('showOptions')) {
				return;
			}

			scope.tooltip ?
				scope.hoverPoly(layer, e.point) :
				scope.clickPoly(layer, e);
		});
	},

	/**
	 * Zoom in to center of clicked polygon
	 *
	 * @param {String} layer
	 * @param {Object} e
	 */
	clickPoly(layer, e) {
		const scope = this;
		const zoom = scope.map.getZoom();

		if (
			zoom > scope.break ||
			scope.inspect ||
			scope.hoverMarker ||
			scope.$public.tooltip ||
			scope.model.$get('showOptions')
		) {
			return;
		}

		const features = scope.$public.getFeatures({
			layers: [layer]
		}, e.point);

		if (
			features.length !== 1 ||
			features[0].layer.id !== layer
		) {
			return;
		}

		scope.$public.center(e.lngLat, {
			animate: true,
			zoom: Math.max(Math.max(zoom + 2, zoom >= 5 ? 8 : 5), 6.4)
		});
	},

	/**
	 * Determine applicable hovered polygon and activate it
	 *
	 * @param {String} layer
	 * @param {Object} point
	 */
	hoverPoly(layer, point) {
		const scope = this;
		const zoom = scope.map.getZoom();

		// Ensure layer is visible within zoom ranges
		if ((
			zoom < scope.break && (
				(layer === 'territories' && zoom < 5) ||
				(layer === 'subterritories' && zoom >= 5)
			)
		)) {
			const features = scope.$public.getFeatures({
				layers: [layer]
			}, point);

			if (features.length) {
				scope.activate(layer, features[0]);
			} else {
				scope.deactivate();
			}
		}
	},

	/**
	 * Show the minimum zoom message
	 *
	 * @param {Object} layer
	 * @param {Object} feature
	 */
	activate(layer, feature) {
		const scope = this;

		if (scope.map.getZoom() >= scope.break) {
			return;
		}

		if (
			scope.hoverFeature &&
			scope.hoverFeature.id === feature.id
		) {
			return;
		}

		if (scope.hoverFeature) {
			scope.map.setFeatureState(scope.hoverFeature, {
				hover: false
			});
		}

		scope.map.setFeatureState(feature, {
			hover: true
		});

		scope.hoverFeature = feature;

		scope.model.$set('status', 'Counting listings');

		scope.getGroup(layer, feature.id, count => {
			scope.model.$merge({
				count: count,
				location: feature.properties.name,
				status: false
			});
		});
	},

	/**
	 * Hide the minimum zoom message
	 *
	 * @param {Number} [zoom]
	 */
	deactivate(zoom) {
		const scope = this;
		zoom = zoom || scope.map.getZoom();

		if (! scope.conf.showPoints && zoom >= scope.break) {
			return;
		}

		scope.model.$merge({
			location: false,
			status: false
		});

		if (scope.hoverFeature) {
			scope.map.setFeatureState(scope.hoverFeature, {
				hover: false
			});
		} else {
			scope.toggleZoom();
		}

		scope.hoverFeature = null;
	}
});